export default __webpack_public_path__ + "static/media/marr5.7d112ce7.jpeg";